"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var props_1 = require("../../../../context/props");
var Icon_1 = __importDefault(require("../../../../../Icon"));
var Label = function () {
    var translate = (0, props_1.usePropsContext)().translate;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Icon_1.default, { kind: "attachFile" }),
        "\u00A0",
        translate('feedbackModal.attachFile')));
};
exports.default = Label;
